import styled from 'styled-components';

import FrontImage from '../../assets/images/LandingPage/frontImg.png';
import theme from '../../assets/theme';
import HybridForm from '../../components/_organisms/HybridForm/HybridForm';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';

const CuriLunchPage: NextPageWithLayout = () => {
  return (
    <LandingPageLayout
      title="Curi-Lunch"
      subTitle="Sign up for a Curi-Lunch"
      primaryActionText="Sign up - It's free"
      image={FrontImage}
      hideBlobs={false}
      disableHeadline={true}
    >
      <PageContainer>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>
          Request a Curipod Curi-Lunch!
        </h1>
        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>
          Fill out this application and schedule a quick PD planning meeting with our
          team! After the meeting, we&apos;ll send your $30 gift card! 🎁
        </h4>
        <HybridForm
          typeformUrl="https://9uq31r57i3q.typeform.com/to/UfAYuFOZ"
          thankYouMessage="Thank you for your interest! Important: You will hear back from us within 24 hours. If you don't:
          1) Check your spam folder
          2) Reach out to eirik@curipod.com"
          metricEventNamePrefix="Curi-Lunch"
        />
      </PageContainer>
    </LandingPageLayout>
  );
};

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  background: ${theme.colors.background};
`;

export default CuriLunchPage;
